import React from 'react';

import MuiMenuList, {
  MenuListProps as MuiMenuListProps,
} from '@mui/material/MenuList';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const MenuList = withCoreProps<MenuListProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<MenuListProps>) => {
    // const classes = useStyles({});
    const clsxClass = clsx(className);

    return (
      <MuiMenuList {...props} className={clsxClass}>
        {children}
      </MuiMenuList>
    );
  },
);

export interface MenuListProps extends MuiMenuListProps, CoreProps {}
